import apiClient from "../apiClient";
import { apiBaseUrl } from "../../config";

export const getWorkpaperByType = async (accountId, type) => {
    return apiClient
        .get(`${apiBaseUrl}/workpapers/admin/${accountId}/${type}`)
        .then((response) => {
            return response;
        });
};

export const createWorkpaper = async (request) => {
    return apiClient
        .post(`${apiBaseUrl}/workpapers/admin`, request)
        .then((response) => {
            return response;
        });
};

export const getWorkpaperTemplates = async () => {
    return apiClient
        .get(`${apiBaseUrl}/workpapers/admin/templates`)
        .then((response) => {
            return response;
        });
};

export const updateWorkpaperTemplates = async (id, request) => {
    return apiClient
        .put(`${apiBaseUrl}/workpapers/admin/templates/${id}`, request)
        .then((response) => {
            return response;
        });
};

export const createWorkpaperDocuments = async (workpaper_id) => {
    return apiClient
        .post(`${apiBaseUrl}/workpapers/admin/${workpaper_id}`)
        .then((response) => {
            return response;
        });
};

export const createWorkpaperAggregation = async (workpaper_id) => {
    return apiClient
        .post(`${apiBaseUrl}/workpapers/aggregation`, { workpaper_id })
        .then((response) => {
            return response;
        });
};